@switch (mode) { @case (LabelMode.DEFAULT) {
<ng-container [ngTemplateOutlet]="default"></ng-container>
} @case (LabelMode.INLINE) {
<ng-container [ngTemplateOutlet]="inline"></ng-container>
} @case (LabelMode.NO_LABEL) {
<ng-container [ngTemplateOutlet]="input"></ng-container>
} }

<ng-template #input>
  <textarea
    #textareaBox
    [class]="`form-control ${minHeightClass}`"
    [ngClass]="{ 'is-invalid': isError }"
    [id]="name"
    [name]="name"
    [placeholder]="placeholder | translate"
    [formControl]="form"
    [rows]="rows"
  ></textarea>
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}
      <ng-container [ngTemplateOutlet]="subLabel"></ng-container
    ></label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}
      <ng-container [ngTemplateOutlet]="subLabel"></ng-container
    ></label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </div>
</ng-template>

<ng-template #subLabel>
  @if (addonLabel !== '' && addonLabel !== '*') {
  <span class="text-danger">({{ addonLabel | translate }})</span>
  } @if (addonLabel !== '' && addonLabel === '*') {
  <span class="text-danger">{{ addonLabel | translate }}</span>
  }
</ng-template>

<ng-template #error>
  @if (isError && showErrorMessage) {
  <span class="error">{{ errorMessage | translate }}</span>
  }
</ng-template>
